export default __webpack_public_path__ + "static/bootstrap-react-d992fb2b60c83d8bd18bd7d4eb84f741.svg";